import React from 'react';
import { Panel, Button, Alert } from 'react-bootstrap';
import { Form, FormGroup, FormControl, ControlLabel, Row, Col } from 'react-bootstrap';
import LoadingPlaceholder from './../../shared/LoadingPlaceholder';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { set_token, customerJourneyLogin, customerJourneyLoginReservation } from './../../../actions';

import isEmpty from 'lodash/isEmpty';

import './login.scss';

const keyImage = require('./../../../images/key.png');

class Login extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      reservationId: '',
      checkInDate: '',
      checkOutDate: '',
      surname: '',
      error: false,
      loginMode: 'check_in'
    };

    this.handleLoginFormChange = this.handleLoginFormChange.bind(this);
    this.handleLoginSubmit = this.handleLoginSubmit.bind(this);
    this.handleLoginReservationSubmit = this.handleLoginReservationSubmit.bind(this);
    this.toggleLoginMode = this.toggleLoginMode.bind(this);
  }

  handleLoginFormChange(event) {
    let changeObj = {};
    changeObj[event.target.id] = event.target.value;
    this.setState(changeObj);
  }

  handleLoginSubmit(event) {
    event.preventDefault();
    this.setState({error: false});

    this.props.actions.customerJourneyLogin(this.state.reservationId, this.state.surname, this.props.currentLanguage, 
      (data) => {
        this.props.actions.setToken(data.token, null, this.props.currentLanguage); // set null context with new token
      },
      () => {
        this.setState({error: true});
      });
  }

  handleLoginReservationSubmit(event) {

    debugger

    event.preventDefault();
    this.setState({error: false});

    this.props.actions.customerJourneyLoginReservation(this.state.checkInDate, this.state.checkOutDate, this.props.token_hotel, this.state.surname, this.props.currentLanguage, 
      (data) => {
        this.props.actions.setToken(data.token, null, this.props.currentLanguage); // set null context with new token
      },
      () => {
        this.setState({error: true});
      },
      this.props.context);
  }

  toggleLoginMode() {
    this.setState({error: false})
    if(this.state.loginMode == 'booking_number') this.setState({loginMode: 'check_in'})
    else this.setState({loginMode: 'booking_number'})
  }

  render() {

    const loginHeader = (
      <div className="shared-login-component__header">
        <p className="text-center"><img src={keyImage} alt="Login" /></p>
        <h5 className="shared-login-component__login-header-text"><strong>{this.props.translate('shared.login.insert_data')}</strong></h5>
        <h6 className="shared-login-component__login-header-text">{this.props.translate('shared.login.access_your_home')}</h6>
      </div>
    );

    const errorAlert = (
      <Alert bsStyle="danger" className="text-center">
        <p>{this.props.translate('shared.login.login_error')}</p>
      </Alert>
    );

    const bookingNumberForm = (
      <Form className="shared-login-component__form" onSubmit={this.handleLoginSubmit}>
        <FormGroup controlId="reservationId">
          <FormControl required type="text" placeholder={this.props.translate('shared.login.booking_number')} onChange={this.handleLoginFormChange} value={this.state.reservationId} minLength="9" maxLength="11"/>
        </FormGroup>
        <FormGroup controlId="surname">
          <FormControl required type="text" placeholder={this.props.translate('shared.login.surname')} onChange={this.handleLoginFormChange} value={this.state.surname} />
        </FormGroup>
        <div className="text-center">
          <LoadingPlaceholder ready={!this.props.login.loading}>
            <Button block bsStyle="primary" type="submit" disabled={isEmpty(this.state.reservationId) || isEmpty(this.state.surname)}>{this.props.translate('shared.login.confirm')}</Button>
          </LoadingPlaceholder>  
        </div>
        <p className="text-center"><Button className="shared-login-component__toggle-login-mode-link" bsStyle="link" onClick={this.toggleLoginMode}>{this.props.translate('shared.login.toggle_to_check_in_mode')}</Button></p>
      </Form>
    );

    const checkInDateForm = (
      <Form className="shared-login-component__form" onSubmit={this.handleLoginReservationSubmit}>
        <Row>
          <Col xs={12} md={6}>
            <FormGroup className="shared-login-component__inline-input" controlId="checkInDate">
              <ControlLabel>{this.props.translate('shared.login.check_in_date')}</ControlLabel>{' '}
              <FormControl required type="date" placeholder={this.props.translate('shared.login.check_in_date')} onChange={this.handleLoginFormChange} value={this.state.checkInDate} />
            </FormGroup>
          </Col>
          <Col xs={12} md={6}>
            <FormGroup className="shared-login-component__inline-input" controlId="checkOutDate">
              <ControlLabel>{this.props.translate('shared.login.check_out_date')}</ControlLabel>{' '}
              <FormControl required type="date" placeholder={this.props.translate('shared.login.check_out_date')} onChange={this.handleLoginFormChange} value={this.state.checkOutDate} />
            </FormGroup>
          </Col>
        </Row>
        
        <FormGroup controlId="surname">
          <FormControl required type="text" placeholder={this.props.translate('shared.login.surname')} onChange={this.handleLoginFormChange} value={this.state.surname} />
        </FormGroup>
        <div className="text-center">
          <LoadingPlaceholder ready={!this.props.login.loading}>
            <Button block bsStyle="primary" type="submit" disabled={isEmpty(this.state.checkInDate) || isEmpty(this.state.checkOutDate) || isEmpty(this.state.surname)}>{this.props.translate('shared.login.confirm')}</Button>
          </LoadingPlaceholder>  
        </div>
        <p className="text-center"><Button className="shared-login-component__toggle-login-mode-link" bsStyle="link" onClick={this.toggleLoginMode}>{this.props.translate('shared.login.toggle_to_booking_number_mode')}</Button></p>
      </Form>
    );

    return (
      <Panel className="shared-login-component" header={loginHeader}>

        {this.state.error ? errorAlert :  null}

        {
          this.state.loginMode == 'booking_number'
            ? bookingNumberForm
            : checkInDateForm
        }
      </Panel>
    );
  }
}

Login.displayName = 'PagesSharedLogin';
Login.propTypes = {};
Login.defaultProps = {};

const mapStateToProps = (state) => {
  return { 
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    token_hotel: state.hotel.apiData.id,
    context: state.commons.context,
    login: state.login
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      customerJourneyLogin: bindActionCreators(customerJourneyLogin, dispatch),
      customerJourneyLoginReservation: bindActionCreators(customerJourneyLoginReservation, dispatch),
      setToken: bindActionCreators(set_token, dispatch)
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./components/pages/shared/Login.js